import { render } from "./applicatReview.vue?vue&type=template&id=5663f25d&scoped=true"
import script from "./applicatReview.vue?vue&type=script&lang=js"
export * from "./applicatReview.vue?vue&type=script&lang=js"

import "./applicatReview.vue?vue&type=style&index=0&id=5663f25d&lang=less&scoped=true"
import "./applicatReview.vue?vue&type=style&index=1&id=5663f25d&lang=less&scoped=true"

import exportComponent from "../../../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5663f25d"]])

export default __exports__